import React from 'react'
import _ from 'lodash'
import classNames from 'classnames'

import {ActivityList} from './activitylist.component'
// import {ActivityChoice} from './activitychoice.component'
import {ActivityListPreview} from './activitylistpreview.component'
import {ActivitySearch} from './activitysearch.component'
import {ActivityEntry} from './activityentry.component'
import {ActivityItem} from './activityitem.component'

export class ActivitiesOverview extends React.Component {
    constructor(props) {
        super(props)    

        this.state = {
            hasActivity: this.props.hasActivity
        }

        _.bindAll(this,
            'getContent'
        )
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.detailSubSection != this.props.detailSubSection) {
            // this.setState({status:nextProps.currentDetailSubStatus})
      
        }
    }

    getContent() {
        switch (this.props.detailSubSection) {
            case this.props.availableDetailSubSections.OVERVIEW:
                return <ActivityList 
                 {...this.props}/>
            case this.props.availableDetailSubSections.SEARCH:
                return <ActivitySearch 
                  {...this.props}/>
            case this.props.availableDetailSubSections.ENTRY:
                return <ActivityEntry 
                  {...this.props}/>
            case this.props.availableDetailSubSections.DETAILS:
                return <ActivityItem
                  {...this.props}/>
            case this.props.availableDetailSubSections.AGENT:
                return 'probably an expanded note form here'
        }
    }

    render() {
        let showContent = this.getContent()

        return (
            <div>
                {showContent}
            </div>
        )
    }
}